import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DictCollectionType } from '@/models/dict.model';

import { IEnvironmentUser } from '@atlas/sdk/lib/namespaces/environment/environment.types';

import { PermissionEnum } from '@/models/global';
import { FieldWithOptionType } from '@/models/case-field.model';
import { PhoneModel } from '@/models/phone.model';
import { ContactModel } from '@/models/contact.model';

export interface GlobalState {
  user: IEnvironmentUser & { ringGroups: string[] };
  userMap: Map<string, IEnvironmentUser>;
  permissionMap: Partial<Record<PermissionEnum, 'all' | 'ring-groups' | 'users'>>;
  dictCollection: DictCollectionType;
  fieldWithOptions: FieldWithOptionType[];
  // call center phone numbers, use to query friendly name
  phones: PhoneModel[];
  touchPoints: ContactModel[];
  sseUuid: string;
}

export const initialState: GlobalState = {
  user: { email: '', id: '', name: '', ringGroups: [] },
  userMap: new Map<string, IEnvironmentUser>(),
  permissionMap: {},
  dictCollection: {},
  fieldWithOptions: [],
  phones: [],
  touchPoints: [],
  sseUuid: '',
};

const globalStore = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<GlobalState['user']>) {
      state.user = action.payload;
    },
    setUserMap(state, action: PayloadAction<GlobalState['userMap']>) {
      state.userMap = action.payload;
    },
    setPermissionMap(state, action: PayloadAction<GlobalState['permissionMap']>) {
      state.permissionMap = action.payload;
    },
    setDictCollection(state, action: PayloadAction<GlobalState['dictCollection']>) {
      state.dictCollection = action.payload;
    },
    setFieldWithOptions(state, action: PayloadAction<GlobalState['fieldWithOptions']>) {
      state.fieldWithOptions = action.payload;
    },
    setPhones(state, action: PayloadAction<GlobalState['phones']>) {
      state.phones = action.payload;
      return state;
    },
    setTouchPoints(state, action: PayloadAction<GlobalState['touchPoints']>) {
      state.touchPoints = action.payload;
      return state;
    },
    setSseUuid(state, action: PayloadAction<GlobalState['sseUuid']>) {
      state.sseUuid = action.payload;
    },
  },
});

export const {
  setUser,
  setUserMap,
  setPermissionMap,
  setDictCollection,
  setFieldWithOptions,
  setPhones,
  setTouchPoints,
  setSseUuid,
} = globalStore.actions;
export default globalStore.reducer;
